import { useEffect, useState } from "react";
import dayjs from "dayjs";

const DateAndTime = () => {
  const [dateTime, setDateTime] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(dayjs());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="gap-2 flex rounded overflow-clip shadow-md">
      <p className="w-24 text-center bg-slate-800 text-white py-2 px-2 font-bold">
        {dateTime.format("HH:mm:ss")}
      </p>
      <p className="py-2 px-4 bg-slate-50 font-bold text-gray-700">
        {dateTime.format("DD.MM")}
      </p>
    </div>
  );
};

export default DateAndTime;
